import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicTrouverPaiement = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Factures et reçus', link: '/topics/paiement/factures'},
    { label: topic.title, link: topic.link},
  ];

  // 


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous trouverez vos paiements. Il s'agit des paiements effectués pour vos inscriptions de moins de 2 ans et tout remboursement éventuel s'y rattachant.
            </p>
            <p className="help-text mt-24">
              Mon compte {">"}
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements</a>
              <br />Cliquez ensuite sur le bouton <strong>Gérer mes paiement.</strong>
            </p>
            <p className="help-text mb-8">
              Il vous suffit alors de cliquer sur la compétition qui vous intéresse pour en voir plus de détails. 
              Si vous souhaitez télécharger un reçu, cliquer sur le bouton <i className="bi bi-filetype-pdf fz-20 ml-8"></i>.
            </p>
            <p className="help-text mt-48">
              En tant qu'orgnisateur, vous trouverez vos versements à venir et effectués dans votre
              <a target='_blank' className="link" href={`#`}>historique des transactions.</a>
            </p>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicTrouverPaiement